'use strict';

var React = require('react');
var _ = require('lodash');
module.exports = function () {
    return React.createElement('span', { 'className': 'tooltip chupchik-' + this.props.chukchikAlignment }, React.createElement('div', {
        'className': 'tooltip-content',
        'ref': this.getContentRef,
        'style': this.getContentStyle(),
        'key': 'content'
    }, this.getChildren()), React.createElement('div', {
        'className': 'tooltip-chupchik',
        'key': 'chupchik',
        'style': this.props.chupchikStyle
    }));
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/bubble.rt.js